import type { IControlConfig, IControlState } from "@/types/ComponentLibrary/component-library";
import { defineStore } from "pinia";

export const controlStateStore = (identifier: string) =>
  defineStore(`control/${identifier}`, {
    state: () => ({
      state: {} as IControlState,
      config: {} as IControlConfig,
      reload: true
    }),
    actions: {
      reloadOptions(){
        
      }
    }
  })(); // <- this is the key right here, by initialising it here

// export const controlStateStore = defineStore("controlState", {
//   state: () => ({
//      controls: new Map() as Map<string, IControlState>
// }),
//   actions: {
//     registerControlState(identifier:string,state : IControlState) {
//         this.controls.set(identifier,state);
//     },
//     patchControl(identifier:string,state:IControlState) {
//         this.controls.set(identifier,state);
//     }
//   },
// });
